"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _excluded = ["clients", "value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledOption = _Selector["default"].StyledOption;
var PLACEHOLDER = 'Выбрать клиента';
var StyledTicketFilterByClient = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByClient__StyledTicketFilterByClient",
  componentId: "sc-19hjs1q-0"
})(["", "{padding:3px 10px 7px 10px;}"], StyledOption);
var StyledClient = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilterByClient__StyledClient",
  componentId: "sc-19hjs1q-1"
})(["display:flex;flex-direction:column;height:100%;"]);
var StyledName = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilterByClient__StyledName",
  componentId: "sc-19hjs1q-2"
})(["color:#17181a;flex-shrink:0;font-size:14px;height:17px;line-height:17px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilterByClient__StyledDescription",
  componentId: "sc-19hjs1q-3"
})(["display:flex;flex-grow:1;height:15px;line-height:15px;", " + &{margin-top:2px;}"], StyledName);
var StyledDescriptionText = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilterByClient__StyledDescriptionText",
  componentId: "sc-19hjs1q-4"
})(["color:#919499;font-size:12px;"]);
var StyledId = (0, _styledComponents["default"])(StyledDescriptionText).withConfig({
  displayName: "TicketFilterByClient__StyledId",
  componentId: "sc-19hjs1q-5"
})(["font-weight:700;"]);
var StyledPhone = (0, _styledComponents["default"])(StyledDescriptionText).withConfig({
  displayName: "TicketFilterByClient__StyledPhone",
  componentId: "sc-19hjs1q-6"
})(["", " + &{margin-left:8px;}"], StyledId);
var TicketFilterByClient = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByClient(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByClient);
    _this = _callSuper(this, TicketFilterByClient, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByClient, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByClient, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return v.value;
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        clients = _this$props2.clients,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      if ((0, _isEmpty2["default"])(clients)) {
        return null;
      }
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return (0, _find2["default"])(clients, {
            value: v
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledTicketFilterByClient, (0, _extends2["default"])({}, props, {
        isMulti: true,
        isSearchable: true,
        onChange: this.handleChange,
        options: clients,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue
      }), function (_ref) {
        var data = _ref.data;
        var name = data.name,
          id = data.id,
          phone = data.phone;
        return /*#__PURE__*/_react["default"].createElement(StyledClient, {
          title: name
        }, /*#__PURE__*/_react["default"].createElement(StyledName, null, name), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, /*#__PURE__*/_react["default"].createElement(StyledId, null, id), phone && /*#__PURE__*/_react["default"].createElement(StyledPhone, null, phone)));
      });
    }
  }]);
}(_react["default"].PureComponent);
var valueProp = _propTypes["default"].string;
TicketFilterByClient.propTypes = {
  className: _propTypes["default"].string,
  clients: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired,
    phone: _propTypes["default"].string,
    value: valueProp.isRequired
  })),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].arrayOf(valueProp.isRequired)
};
TicketFilterByClient.defaultProps = {
  className: '',
  clients: null,
  name: '',
  onChange: Function.prototype,
  value: null
};
var _default = exports["default"] = TicketFilterByClient;